// extracted by mini-css-extract-plugin
export var overlay = "cookienotice-module--overlay--1UzIP";
export var container = "cookienotice-module--container--2ce1u";
export var buttons_container = "cookienotice-module--buttons_container--3MShm";
export var checkboxIconContainer = "cookienotice-module--checkboxIconContainer--irqCu";
export var checkboxIcon = "cookienotice-module--checkboxIcon--tu-Kc";
export var error = "cookienotice-module--error--2gVGD";